import { z } from 'zod';
import { isAutoMttFrequencyUnitType, isAutoMttRecentHandsType } from '../../../types/autoMttTypes';
import { isCurrency } from '../../../types/sharedTypes';
export const TourneyDetailsSchema = z.object({
    id: z.number(),
    name: z.string(),
    infoMarkdown: z.string().optional(),
    secsUntilStart: z.number().optional(),
    timeUntilStartStr: z.string().optional(),
    buyIn: z.number(),
    currency: z.custom(isCurrency),
    /**
     * how many frequency units separate start times of the tourney
     */
    frequencyCount: z.number().optional(),
    frequencyUnitType: z.custom(isAutoMttFrequencyUnitType).optional(),
    jacksRequired: z.number().optional(),
    extraChipsToWin: z.number().optional(),
    extraJacksToWin: z.number().optional(),
    addExtraAmountToPrizePool: z.optional(z.boolean()),
    isPowerPlayerOnly: z.boolean().optional(),
    ticketToWin: z.string().optional(),
    numTicketsRequired: z.number().optional(),
    ticketRequired: z.string().optional(),
    recentHandsRequirement: z
        .object({
        numHands: z.number(),
        numDays: z.number(),
        handType: z.custom(isAutoMttRecentHandsType)
    })
        .optional(),
    powerPlayerBonusStartingChipsPercent: z.number().optional()
});
const ShowTourneyDetailsInboundSchema = TourneyDetailsSchema.transform(
// add _type
({ ...rest }) => ({
    _type: 'show_tourney_details',
    ...rest
}));
export const SHOW_TOURNEY_DETAILS_PAYLOAD_DEFINITION = {
    zodSchema: ShowTourneyDetailsInboundSchema
};
